import dayjs from "dayjs";

const state = {
    selectedOperationId: '',
    selectedHeaderIdSet: new Set(),
    loading: false,
    data: {},
    dataMap: null,
    dataIsSet: false,
    schedulingForm: null,
    joinHeaderIdSet: new Set(),

    //loadRateItem
    itemPos: null,
    targetPos: null,
    itemOff: false,
    locationList: [],
    lockEventHappened: false,

    //loadRateCell
    /** display mode
     * 0 显示总计
     * //1 显示子项分割
     * //2 显示更新变化
     * 3 单元格选择
     * 4 显示锁定
     */
    displayMode: 0,
    cellReColored: 0,
    displayJoinHeader: null,
    selectedOperationHeaderId: '',

    //SithMesPrdPpHeaderList
    saveResult: false,

    //loadRateMatrix
    operationPosMap: null,
    locateOperationPos: null,
    needScroll: false,
    forceScroll: false,
    calendarManagement: false,
    addShiftRule: false,
    downtimeCalendar: {},

    //loadRateActiveLocationList
    showLocationIdSet: null,

    //loadRateHeaderList
    headerListTempLock: false,
    needScrollToHeader: false,

};
const getters = {
    scheduledData: state => state.data.workStationScheduledResultMap,
    posData: state => {
        return function ({locationId, dateStr}) {
            let locationValue = state.dataMap.get(locationId);
            if (locationValue !== undefined && locationValue !== null) {
                let dayValue = locationValue.get(dateStr);
                if (dayValue !== undefined && dayValue !== null) {
                    return dayValue;
                }
            }
            return {};
        };
    },
    operationMap: state => state.data.operationMap,
    headerMap: state => state.data.headerMap,
    operationPosMap: state => state.operationPosMap,
    headerChangedResultOverView: state => state.data.headerChangedResultVo,
};
const actions = {
    collectOriginData(context, data) {
        let map = new Map();
        let operationPosMap = new Map();
        //深拷贝对象
        // let data = JSON.parse(JSON.stringify(context.state.data));
        let scheduledData = data.workStationScheduledResultMap;

        for (let locationId in scheduledData) {
            if (scheduledData.hasOwnProperty(locationId)) {
                let dayMap = new Map();
                let resultOfDayMap = scheduledData[locationId].scheduleResultOfDayMap;
                for (let dateStr in resultOfDayMap) {
                    if (resultOfDayMap.hasOwnProperty(dateStr)) {
                        //创建pos data map对象
                        dayMap.set(dateStr, resultOfDayMap[dateStr]);
                        let posMap = resultOfDayMap[dateStr].operationSchedulePosVoMap;
                        if (posMap !== null && posMap !== undefined) {
                            let values = Object.values(posMap);
                            //初始化operation定位信息
                            for (let item of values) {
                                if (!operationPosMap.has(item.posIdOperation) || item.posSeq === 1) {
                                    operationPosMap.set(item.posIdOperation, locationId + '*' + dateStr);
                                }
                            }
                            //排序
                            values.sort((a, b) => {
                                if (a.posForecastBeginTime > b.posForecastBeginTime) {
                                    return 1;
                                }
                                if (a.posForecastBeginTime < b.posForecastBeginTime) {
                                    return -1;
                                }
                                return 0;
                            });
                            data.workStationScheduledResultMap[locationId].scheduleResultOfDayMap[dateStr].operationSchedulePosVoMap = values;
                        }
                    }
                }
                map.set(locationId, dayMap);
            }
        }

        let joinHeaderIdList = data.joinHeaderIdList;
        if (joinHeaderIdList !== undefined && joinHeaderIdList instanceof Array && joinHeaderIdList.length > 0) {
            let tempSet = new Set();
            for (let item of joinHeaderIdList) {
                tempSet.add(item);
            }
            context.commit('setJoinHeaderIdSet', tempSet);
        }
        //重新赋值
        context.commit('setData', data);
        context.commit('setDataMap', map);
        context.commit('setOperationPosMap', operationPosMap);

        let calendarList = data.calendarVoList;
        if (calendarList) {
            let temp = {};
            for (let c of calendarList) {
                if (c.calendarType === 5 && c.beginTime && c.endTime) {
                    let item = {
                        beginTime: dayjs(c.beginTime),
                        endTime: dayjs(c.endTime)
                    }
                    let key = `${c.mstLocationId}`;
                    if (key in temp) {
                        temp[key].push(item);
                    } else {
                        temp[key] = [item];
                    }
                }
            }
            context.commit('setDowntimeCalendar', temp);
        }
    },
    //选择工序并定位
    selectOperation(context, operationId) {
        context.commit('setSelectedOperationId', operationId);
        context.commit('setSelectedOperationHeaderId', operationId === '' ? '' : context.getters.operationMap[operationId].prdPpHeaderId);
        context.dispatch('locateOperation', operationId);
    },
    //定位工序位置
    locateOperation(context, operationId) {
        let map = context.getters.operationPosMap;
        if (map != null && map instanceof Map && map.has(operationId)) {
            context.commit('setLocateOperationPos', map.get(operationId));
        }
    },
    //切换锁定事件状态
    changeLockStatus(context, {operationId, val}) {
        let data = JSON.parse(JSON.stringify(context.state.data));
        data.operationMap[operationId].isLocked = val;
        context.commit('setData', data);
        if (!context.state.lockEventHappened) {
            context.commit('setLockEventHappened', true);
        }
    },
};
const mutations = {
    setSelectedOperationId(state, operationId) {
        state.selectedOperationId = operationId;
        state.cellReColored++;
    },
    setSelectedHeaderIdSet(state, selectedHeaderIdSet) {
        let temp = new Set();
        for (let item of selectedHeaderIdSet) {
            temp.add(item);
        }
        state.selectedHeaderIdSet = temp;
        state.cellReColored++;
    },
    setData(state, data) {
        state.data = data;
        state.dataIsSet = true;
        state.cellReColored++;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setItemPos(state, itemPos) {
        state.itemPos = itemPos;
    },
    setDisplayMode(state, mode) {
        state.displayMode = mode;
        state.cellReColored++;
    },
    setTargetPos(state, pos) {
        state.targetPos = pos;
    },
    setItemOff(state, val) {
        state.itemOff = val;
    },
    setDataMap(state, val) {
        state.dataMap = val;
    },
    setSaveResult(state, val) {
        state.saveResult = val;
    },
    setOperationPosMap(state, map) {
        state.operationPosMap = map;
    },
    setLocateOperationPos(state, pos) {
        state.locateOperationPos = pos;
    },
    setNeedScroll(state, val) {
        state.needScroll = val;
    },
    setForceScroll(state, val) {
        state.forceScroll = val;
    },
    setLocationList(state, list) {
        state.locationList = list;
    },
    setLockEventHappened(state, val) {
        state.lockEventHappened = val;
    },
    setJoinHeaderIdSet(state, val) {
        state.joinHeaderIdSet = val;
        state.displayJoinHeader = false;
    },
    setDisplayJoinHeader(state, val) {
        state.displayJoinHeader = val;
        state.cellReColored++;
    },
    setShowLocationIdSet(state, val) {
        state.showLocationIdSet = val;
    },
    setHeaderListTempLock(state, val) {
        state.headerListTempLock = val;
    },
    setSchedulingForm(state, val) {
        state.schedulingForm = val;
    },
    setNeedScrollToHeader(state, val) {
        state.needScrollToHeader = val;
    },
    setCalendarManagement(state, val) {
        state.calendarManagement = val;
    },
    setSelectedOperationHeaderId(state, val) {
        state.selectedOperationHeaderId = val;
    },
    setAddShiftRule(state, val) {
        state.addShiftRule = val;
    },
    setDowntimeCalendar(state, val) {
        state.downtimeCalendar = val;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
